module.exports = __webpack_public_path__ + "media/barcelona musica/hall_seats-19b3d32d.jpg";